export default "__VITE_ASSET__534b6864__"